import styled from 'styled-components';

const FormContainer = styled.div`
	width: 340px;
	padding: 0 20px;
	max-width: 100%;
	margin-left: auto;
	margin-right: auto;
`;

export default FormContainer;



// WEBPACK FOOTER //
// ./src/components/Common/LoggedOutFormContainer/LoggedOutFormContainer.js